import React from 'react';
import { ButtonDropdown, ButtonDropdownProps } from '@amzn/awsui-components-core';

import constants from '../../common/constants';
import BrowserHistory from '../utils/BrowserHistory';
import RouterPaths from '../../common/RouterPaths';

const HeaderGuidanceDropdown = () => {
  const dropDownItems = [
    { text: constants.ALL_GUIDANCE, id: constants.ALL_GUIDANCE },
    { text: constants.AUTHOR_GUIDANCE, id: constants.AUTHOR_GUIDANCE },
  ];

  const handleDropdownClick = (event: CustomEvent<ButtonDropdownProps.ItemClickDetails>) => {
    const eventId = event.detail.id;
    switch (eventId) {
      case constants.ALL_GUIDANCE:
        BrowserHistory.push(RouterPaths.HOME_PAGE);
        break;
      case constants.AUTHOR_GUIDANCE:
        BrowserHistory.push(RouterPaths.MY_CONTENT);
        break;
      default:
        break;
    }
  };

  return (
    <ButtonDropdown items={dropDownItems} onItemClick={handleDropdownClick}>
      {constants.GUIDANCE}
    </ButtonDropdown>
  );
};

export default HeaderGuidanceDropdown;
